// =========================================================
// * Vuetify Material Dashboard PRO - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'vue-search-select/dist/VueSearchSelect.css'

// import './assets/style/materialdesignicons.min.css'

import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'

// import moment from 'moment'
import moment from 'moment-timezone'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
moment.tz.setDefault('Asia/Shanghai')
// moment.tz.setDefault('UTC')
// 将 $moment 挂载到 prototype 上，在组件中可以直接使用 this.$moment 访问
Vue.prototype.$moment = moment

import './permission' // permission control
Vue.config.productionTip = false

// 版本检查：部署新版本后强制刷新，防止白屏
function checkVersion() {
  fetch('/version.json?t=' + Date.now())
    .then(res => res.json())
    .then(data => {
      const localVersion = localStorage.getItem('app_version')
      if (localVersion && localVersion !== data.version) {
        localStorage.setItem('app_version', data.version)
        location.reload()
      } else if (!localVersion) {
        localStorage.setItem('app_version', data.version)
      }
    })
    .catch(() => {})
}
checkVersion()

// chunk 加载失败自动刷新（解决浏览器缓存 index.html 导致白屏）
window.addEventListener('error', function(e) {
  if (e.target && e.target.tagName && e.target.src && e.target.src.indexOf('.js') !== -1) {
    localStorage.removeItem('app_version')
    location.reload()
  }
}, true)

import VuetifyConfirm from 'vuetify-confirm'
Vue.use(VuetifyConfirm, {vuetify,
  buttonTrueText: '确认',
  buttonFalseText: '取消',
  color: 'warning',
  icon: 'mdi-alert-circle-outline',
  title: '温馨提示',
  width: 350,
  property: '$confirm'})

  // Vue.use(VuetifyConfirm, {vuetify,
  //   buttonTrueText: '确认',
  //   buttonFalseText: '取消',
  //   color: 'warning',
  //   icon: 'mdi-alert-circle-outline',
  //   title: '温馨提示',
  //   width: 350,
  //   property: '$confirms'})

import Print from 'vue-print-nb'
Vue.use(Print)

var VueTruncate = require('vue-truncate-filter')
Vue.use(VueTruncate)

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import excel from 'vue-excel-export'
Vue.use(excel)

// 路由问题解决时间过了一段时间再次访问就是白屏问题
import Navigation from 'vue-navigation'
Vue.use(Navigation, {router})

import { vueBaberrage } from 'vue-baberrage'
Vue.use(vueBaberrage)

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')

